<template>
	<router-view> </router-view>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";

export default {
	mounted() {
		if (
			this.locationEventManager &&
			this.locationEventManager?.channels?.locationChanged
		) {
			this.locationEventManager.listener.on(
				this.locationEventManager.channels.locationChanged,
				(data) => {
					this.setLocation(data.data);
				}
			);
		}
		// this.fetchMarketListData();
	},
	computed: {
		...mapGetters({
			modules: "availableModules",
		}),
		...mapState({
			marketList: (state) => state["market"].marketList,
		}),

		locationEventManager() {
			return this.modules["location"]?.eventManager?.location;
		},
	},
	methods: {
		...mapActions({
			setLocation: "market/setLocation",
			fetchMarketListData: "market/fetchMarketList",
		}),
	},
};
</script>
